import { Subject } from 'rxjs';
import { WebSocketApi } from './data/WebSocketApi';
import { FixtureDetailed } from "./model/FixtureDetailed";
import { LiveEvents } from "./model/LiveEvents";
import { Observable } from 'rxjs';

export enum ACTION_TYPE {
  FIXTURE_START_LOAD = "fixture-detailed/start-load",
  FIXTURE_LOADED = "fixture-detailed/loaded",
  FIXTURE_ERROR = "fixture-detailed/error",
  LIVE_DATA_START_LOAD = "fixture-detailed/live/start_load",
  LIVE_DATA_UNSOCKET = "fixture-detailed/live/unload",
  LIVE_DATA_LOADED = "fixture-detailed/live/loaded",
  LIVE_DATA_ERROR = "fixture-detailed/live/error",
  HISTORIC_DATA_START_LOAD = "fixture-detailed/historic/start_load",
  HISTORIC_DATA_UNLOAD = "fixture-detailed/historic/unload",
  HISTORIC_DATA_LOADED = "fixture-detailed/historic/loaded",
  HISTORIC_DATA_ERROR = "fixture-detailed/historic/error",
}

export type Action =
  { type: ACTION_TYPE.FIXTURE_START_LOAD; id: number }
  | { type: ACTION_TYPE.FIXTURE_LOADED; fixture: FixtureDetailed }
  | { type: ACTION_TYPE.FIXTURE_ERROR; id: number, error: Error }
  | { type: ACTION_TYPE.LIVE_DATA_START_LOAD; id: number, legacy: boolean }
  | { type: ACTION_TYPE.LIVE_DATA_UNSOCKET; id: number }
  | { type: ACTION_TYPE.LIVE_DATA_LOADED; id: number, liveData: Observable<LiveEvents.Event>, socket: WebSocketApi | undefined | null }
  | { type: ACTION_TYPE.LIVE_DATA_ERROR; id: number, error: Error }
  | { type: ACTION_TYPE.HISTORIC_DATA_START_LOAD; id: number }
  | { type: ACTION_TYPE.HISTORIC_DATA_LOADED; id: number, liveData: Observable<LiveEvents.Event> }
  | { type: ACTION_TYPE.HISTORIC_DATA_ERROR; id: number, error: Error };
